export const CompetitionLevelsEnum = {
    SUPER_SOCIAL: 'Super Social',
    RECREATIONAL: 'Recreational',
    INTERMEDIATE: 'Intermediate',
    UPPER_INTERMEDIATE: 'Upper Intermediate',
    COMPETITIVE: 'Competitive',
};
export const SportPageProgramTypesEnum = Object.freeze({
    CLASS: 'CLASS',
    CLINIC: 'CLINIC',
    DROPIN: 'DROPIN',
    LEAGUE: 'LEAGUE',
    PICKUP: 'PICKUP',
    PRACTICE: 'PRACTICE',
    RENTAL: 'RENTAL',
    SERIES: 'SERIES',
    TOURNAMENT: 'TOURNAMENT',
});
